import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class LadderDown extends LevelChangerThing {
	static key = "LadderDown";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const ladder = new LadderDown(xy, (props?.destination as number) ?? 0);
		board.putThing(ladder);
		return [ladder];
	}

	static deserialize(data: any): LadderDown {
		const l = new LadderDown(deserializeXY(data.xy), data.destinationLevel);
		l.visualId = data.visualId;
		return l;
	}
}
